
import { Medium, Review, MediumDomain } from '../types';

// --- DONNÉES DE BASES POUR LA GÉNÉRATION ---
const femaleNames = [
  "Isabelle", "Nathalie", "Sylvie", "Catherine", "Françoise", "Monique", 
  "Martine", "Sandrine", "Véronique", "Valérie", "Sophie", "Marie", "Julie", "Céline", 
  "Aurélie", "Elodie", "Chantal", "Dominique", "Patricia", "Anne", "Brigitte", "Corinne", 
  "Laurence", "Caroline", "Christine", "Nicole", "Béatrice", "Virginie", "Stéphanie",
  "Camille", "Léa", "Manon", "Chloe", "Sarah", "Océane", "Inès", "Justine", "Clara", "Morgane",
  "Elsa", "Jade", "Louise", "Alice", "Zoe", "Eva", "Lisa", "Charlotte", "Amandine",
  "Audrey", "Noémie", "Marion", "Mathilde", "Anaïs", "Lucie", "Emilie", "Florence", "Hélène",
  "Magali", "Sabrina", "Alexandra", "Christelle", "Delphine", "Gaëlle", "Ingrid", "Jessica",
  "Karine", "Laetitia", "Mélanie", "Myriam", "Nadège", "Peggy", "Severine", "Sonia", "Tatiana"
];

const maleNames = [
  "Michel", "Philippe", "Alain", "Christian", "Jacques", "Jean", "Stéphane", 
  "Patrick", "Nicolas", "Thomas", "Antoine", "Pierre", "Lucas", "Raphaël", "Gabriel", 
  "Julien", "Laurent", "Eric", "Olivier", "Thierry", "Pascal", "Christophe", "Frédéric",
  "Maxime", "Alexandre", "Romain", "Anthony", "Adrien", "Bastien", "Vincent", "Hugo",
  "Louis", "Arthur", "Leo", "Nathan", "Paul", "Enzo", "Mathieu", "Guillaume", "Sébastien",
  "David", "Florian", "Clément", "Benjamin", "Damien", "Arnaud", "Xavier", "Bertrand",
  "Alexis", "Axel", "Boris", "Bruno", "Cédric", "Cyril", "Denis", "Fabrice", "Gilles",
  "Grégory", "Hervé", "Jérôme", "Lionel", "Ludovic", "Mickaël", "Régis", "Renaud", "Sylvain"
];

const specialtiesList = [
  "Tarot de Marseille", "Astrologie Humaniste", "Médium Pur", "Numérologie", 
  "Pendule", "Cartomancie", "Clairvoyance", "Magnétisme", "Runes", 
  "Voyance sur photo", "Communication défunt", "Oracle de Belline", "Oracle Gé",
  "Astrologie Karmique", "Tarot des Anges", "Cafédomancie", "Yi King", "Radiesthésie"
];

// FRAGMENTS DE PHRASES ENRICHIS (COMBINAISONS INFINIES)
const reviewFragments = {
    openers: [
        "Vraiment bluffant,", "Incroyable expérience,", "Merci du fond du cœur,", "Je suis sans voix,", 
        "Consultation au top,", "Retour +++ pour vous,", "Quelle précision !", "Je n'y croyais plus mais",
        "Tout simplement merci,", "Un grand moment,", "Impressionnant,", "Je suis rassurée,", 
        "Une belle découverte,", "Merci pour votre honnêteté,", "Très bonne analyse,", "Wouah,",
        "Je ne m'attendais pas à ça,", "Vous m'avez ouvert les yeux,", "Exceptionnel,", "Mille mercis,",
        "Quelle clarté,", "Juste parfait,", "Je recommande vivement,", "Un échange magique,",
        "Merci pour votre lumière,", "Vous avez vu juste,", "Stupéfiant de vérité,", "Une consultation qui change tout,",
        "Je suis bouleversée,", "Bravo pour cette vision,", "Vous êtes formidable,", "Merci pour cette guidance,",
        "Une aide précieuse,", "Quel don incroyable,", "Vous avez tout cerné,", "Je sors apaisée,",
        "Merci d'être là,", "Une voyance de haute qualité,", "Je confirme vos dires,", "C'est exactement ça,",
        "J'avais des doutes, mais", "Une consultation éclairante,", "Comme d'habitude, parfait,", "Quel talent,",
        "Merci pour votre patience,", "Une voix qui apaise,", "Des révélations chocs,", "Je suis scotchée,"
    ],
    predictions: [
        "vous aviez raison pour le retour de communication.", "la rencontre annoncée a bien eu lieu.", 
        "il m'a recontacté exactement dans les délais.", "j'ai obtenu le poste comme vous l'aviez vu.",
        "tout s'est déroulé comme prévu pour mon déménagement.", "la situation s'est débloquée soudainement.",
        "vos ressentis sur son état d'esprit étaient exacts.", "les détails donnés étaient stupéfiants.",
        "la signature s'est faite à la date prédite.", "le message est arrivé comme annoncé.",
        "j'ai eu les nouvelles que j'attendais.", "votre vision sur mon couple était juste.",
        "les choses bougent enfin comme vous l'avez dit.", "le blocage s'est levé rapidement.",
        "j'ai reçu l'appel dont vous m'aviez parlé.", "votre prédiction s'est réalisée ce matin.",
        "il est revenu vers moi hier soir.", "le contrat a été signé sans problème.",
        "la vente de la maison s'est confirmée.", "j'ai réussi mon examen grâce à vos conseils.",
        "la vérité a fini par éclater.", "nous nous sommes réconciliés comme prévu.",
        "j'ai enfin trouvé la paix grâce à vous.", "la réponse administrative est arrivée positive.",
        "mon fils a bien eu son orientation.", "la grossesse s'est confirmée.", 
        "j'ai évité le piège que vous m'aviez décrit.", "le voyage s'est fait dans les conditions dites.",
        "le prêt a été accepté finalement.", "la justice m'a donné raison comme vous l'aviez vu.",
        "il a enfin avoué ses sentiments.", "la rupture était inévitable comme annoncé."
    ],
    qualities: [
        "Une grande douceur dans la voix.", "Sans aucune complaisance.", "Rapide et direct.", 
        "Beaucoup d'empathie et de chaleur.", "Un don rare et précieux.", "Une voyance sans perte de temps.",
        "Très humaine et à l'écoute.", "Une précision chirurgicale.", "Vous m'avez redonné espoir.",
        "Une guidance éclairée.", "Des détails que personne ne pouvait savoir.", "Une connexion immédiate.",
        "Une voix apaisante qui fait du bien.", "Vous cernez les gens très vite.", "Une analyse fine et psychologique.",
        "Direct au but, j'adore.", "Vous ne posez aucune question, c'est fou.", "Une vraie professionnelle.",
        "Pas de blabla, que du vrai.", "Vous avez lu en moi comme dans un livre.", "Une écoute bienveillante.",
        "Des flashs précis et datés.", "Une intégrité qui rassure.", "Vous êtes mon phare dans la nuit.",
        "Une énergie incroyable se dégage de vous.", "Vous avez su trouver les mots justes.",
        "Un accueil chaleureux.", "Vous ne comptez pas votre temps.", "Une bienveillance rare.",
        "Beaucoup de détails visuels.", "Une franchise qui fait du bien."
    ],
    closers: [
        "Je recommande les yeux fermés.", "Je reviendrai vers vous.", "À très bientôt.", 
        "Mille mercis.", "Je vous tiens au courant.", "À consulter absolument.", 
        "Bravo pour votre don.", "Vous êtes mon ange gardien.", "Je vous embrasse.",
        "Merci pour tout.", "À très vite pour les retours.", "Une perle rare.",
        "Je vous ai déjà recommandé à mes amies.", "Prenez soin de vous.", "Gratitude infinie.",
        "Je vous rappellerai sans hésiter.", "Merci de m'avoir guidée.", "Vous êtes unique.",
        "Une belle âme.", "Je garde confiance grâce à vous.", "Que Dieu vous protège.",
        "Merci pour votre patience.", "Je vous adore.", "À bientôt pour la suite.",
        "Ne changez rien.", "Vous êtes la meilleure.", "Merci pour cet échange.",
        "Je vous garde dans mes favoris.", "À très vite.", "Bonne continuation."
    ]
};

const generateUniqueReviewText = (): string => {
    const opener = reviewFragments.openers[Math.floor(Math.random() * reviewFragments.openers.length)];
    const prediction = reviewFragments.predictions[Math.floor(Math.random() * reviewFragments.predictions.length)];
    const quality = reviewFragments.qualities[Math.floor(Math.random() * reviewFragments.qualities.length)];
    const closer = reviewFragments.closers[Math.floor(Math.random() * reviewFragments.closers.length)];
    
    const rand = Math.random();
    if (rand < 0.33) {
        return `${opener} ${quality} ${prediction} ${closer}`;
    } else if (rand < 0.66) {
        return `${opener} ${prediction} ${quality} ${closer}`;
    } else {
        return `${opener} ${prediction} ${closer}`;
    }
};

const generateReviews = (count: number): Review[] => {
    const reviews: Review[] = [];
    
    // Optimisation : Limite hardcodée pour éviter le crash sur mobile ou petites configs
    // On génère max 150 avis par médium au chargement, c'est largement suffisant pour l'UI
    const displayCount = Math.min(count, 150); 
    
    for(let i = 0; i < displayCount; i++) {
        const nameList = Math.random() > 0.5 ? femaleNames : maleNames;
        const name = nameList[Math.floor(Math.random() * nameList.length)];
        const initial = String.fromCharCode(65 + Math.floor(Math.random() * 26));
        
        const r = Math.random();
        let rating = 5;
        if (r > 0.85) rating = 3;
        else if (r > 0.6) rating = 4;

        const daysAgo = Math.floor(Math.random() * 120);
        const timestamp = Date.now() - (daysAgo * 24 * 60 * 60 * 1000) - Math.floor(Math.random() * 86400000);
        
        let dateStr = "";
        if (daysAgo === 0) dateStr = "Aujourd'hui";
        else if (daysAgo === 1) dateStr = "Hier";
        else if (daysAgo < 7) dateStr = `Il y a ${daysAgo} jours`;
        else if (daysAgo < 30) dateStr = `Il y a ${Math.floor(daysAgo / 7)} semaine${Math.floor(daysAgo / 7) > 1 ? 's' : ''}`;
        else dateStr = `Il y a ${Math.floor(daysAgo / 30)} mois`;

        reviews.push({
            id: `rev-${i}-${timestamp}-${Math.random()}`,
            author: `${name} ${initial}.`,
            rating: rating,
            text: generateUniqueReviewText(),
            date: dateStr,
            timestamp: timestamp
        });
    }
    
    return reviews.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
}

const shuffleArray = <T>(array: T[]): T[] => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

// --- PROFILS STARS (FIXES) ---
const STAR_MEDIUMS: Partial<Medium>[] = [
    {
        name: "Maud K.",
        specialties: ["Voyance Pure", "Flashs Directs", "Sans Support"],
        description: "Je ne pose AUCUNE question. Votre voix suffit à déclencher mes flashs visuels et auditifs. Spécialiste des situations sentimentales complexes, je vous livre la vérité brute, sans complaisance mais avec bienveillance. Mon don est héréditaire.",
        imageUrl: "https://randomuser.me/api/portraits/women/68.jpg",
        status: 'available',
        rating: 4.9,
        reviews: 12453,
        experienceYears: 17,
        tags: ["Certifié IMAD", "Coup de Cœur", "Incontournable"],
        temperament: 'strict'
    },
    {
        name: "David S.",
        specialties: ["Tarot de Marseille", "Numérologie", "Coach Pro"],
        description: "Expert des domaines professionnels et financiers. J'utilise le Tarot de Marseille pour dater précisément les événements à venir. Mes consultations sont des plans d'action concrets pour votre réussite. Je ne vends pas de rêve, je construis votre avenir.",
        imageUrl: "https://randomuser.me/api/portraits/men/32.jpg",
        status: 'busy',
        rating: 4.8,
        reviews: 8912,
        experienceYears: 14,
        tags: ["Certifié IMAD", "Top Expert"],
        temperament: 'analytique'
    },
    {
        name: "Sarah L.",
        specialties: ["Médium Spirituelle", "Communication Défunt", "Pendule"],
        description: "Médium pure de naissance, je suis un canal entre vous et l'invisible. Mes ressentis sont immédiats. Je capte les états d'esprit et les intentions cachées de votre entourage. Une consultation spirituelle pour retrouver la paix intérieure.",
        imageUrl: "https://randomuser.me/api/portraits/women/44.jpg",
        status: 'available',
        rating: 5.0,
        reviews: 5621,
        experienceYears: 9,
        tags: ["Certifié IMAD", "Coup de Cœur", "Nouveau"],
        temperament: 'chaleureux'
    },
    {
        name: "Raphaël V.",
        specialties: ["Astrologie", "Vision Pure", "Amour Passion"],
        description: "L'astrologie ne ment jamais. En combinant votre thème astral et mes visions, je perçois l'alchimie charnelle et les liens passionnels. Spécialiste des retours affectifs et des âmes sœurs. Magnétisme et sincérité garantis.",
        imageUrl: "https://randomuser.me/api/portraits/men/85.jpg",
        status: 'available',
        rating: 4.7,
        reviews: 15304,
        experienceYears: 16,
        tags: ["Certifié IMAD", "Référence"],
        temperament: 'sensuel'
    },
    {
        name: "Estelle B.",
        specialties: ["Cartomancie", "Oracle Gé", "Conseil Couple"],
        description: "Plus de 15 ans d'expérience en cabinet. Je lis dans les cartes comme dans un livre ouvert. Si vous avez des doutes sur la fidélité de votre partenaire ou l'avenir de votre couple, je vous donnerai les réponses claires que vous attendez.",
        imageUrl: "https://randomuser.me/api/portraits/women/90.jpg",
        status: 'busy',
        rating: 4.9,
        reviews: 9238,
        experienceYears: 17,
        tags: ["Certifié IMAD", "Top Expert"],
        temperament: 'analytique'
    },
    {
        name: "Claude M.",
        specialties: ["Flashs", "Magnétisme", "Bien-être"],
        description: "Je travaille par vibration de la voix. Dès les premières secondes, je perçois votre aura et les événements qui arrivent vers vous. Mon magnétisme vous aidera aussi à apaiser vos angoisses lors de la consultation.",
        imageUrl: "https://randomuser.me/api/portraits/men/55.jpg",
        status: 'available',
        rating: 4.6,
        reviews: 4109,
        experienceYears: 8,
        tags: ["Certifié IMAD", "Nouveau"],
        temperament: 'mystique'
    },
    {
        name: "Elena R.",
        specialties: ["Oracle Belline", "Désir & Sentimental", "Rêves"],
        description: "Spécialiste du domaine affectif et de l'alchimie secrète depuis 15 ans. Vos rêves sont des messages, je les décode. L'Oracle de Belline me permet de capter les pensées intimes et les retours d'amour. Douceur et magnétisme.",
        imageUrl: "https://randomuser.me/api/portraits/women/23.jpg",
        status: 'available',
        rating: 4.8,
        reviews: 6782,
        experienceYears: 15,
        tags: ["Certifié IMAD", "Coup de Cœur"],
        temperament: 'sensuel'
    },
    {
        name: "Marc D.",
        specialties: ["Numérologie", "Business", "Finance"],
        description: "Votre date de naissance est un code secret. Je l'analyse pour débloquer votre situation financière. Idéal pour les entrepreneurs et les choix de carrière difficiles. Pas de complaisance.",
        imageUrl: "https://randomuser.me/api/portraits/men/11.jpg",
        status: 'available',
        rating: 4.7,
        reviews: 3245,
        experienceYears: 10,
        tags: ["Certifié IMAD", "Top Expert"]
    },
    {
        name: "Sofia M.",
        specialties: ["Voyance Pure", "Sans Support", "Flashs"],
        description: "Je suis médium auditive. J'entends ce que l'on vous cache. Si vous voulez savoir ce qu'il/elle pense vraiment de vous, appelez-moi. Je lève le voile sur les non-dits.",
        imageUrl: "https://randomuser.me/api/portraits/women/79.jpg",
        status: 'busy',
        rating: 4.9,
        reviews: 11007,
        experienceYears: 17,
        tags: ["Certifié IMAD", "Incontournable"]
    },
    {
        name: "Lucas T.",
        specialties: ["Tarot Égyptien", "Vies Antérieures", "Karma"],
        description: "Vos blocages actuels viennent souvent du passé. Le Tarot Égyptien et ma vision karmique permettent de briser les schémas répétitifs en amour. Libérez-vous.",
        imageUrl: "https://randomuser.me/api/portraits/men/42.jpg",
        status: 'available',
        rating: 4.6,
        reviews: 2891,
        experienceYears: 9,
        tags: ["Certifié IMAD", "Nouveau"]
    },
    {
        name: "Chloé V.",
        specialties: ["Pendule", "Magnétisme", "Objets Perdus"],
        description: "Une réponse par OUI ou NON ? Mon pendule est infaillible. Je suis également réputée pour retrouver les objets perdus et réharmoniser les énergies à distance.",
        imageUrl: "https://randomuser.me/api/portraits/women/33.jpg",
        status: 'available',
        rating: 4.5,
        reviews: 1954,
        experienceYears: 8,
        tags: ["Certifié IMAD"]
    },
    {
        name: "Jean-Pierre",
        specialties: ["Astrologie", "Tarot", "Finance"],
        description: "Ancien trader devenu astrologue. Je combine l'analyse des cycles planétaires et le tarot pour vous conseiller dans vos investissements et votre carrière. Pragmatique et efficace.",
        imageUrl: "https://randomuser.me/api/portraits/men/66.jpg",
        status: 'away',
        rating: 4.8,
        reviews: 5432,
        experienceYears: 14,
        tags: ["Certifié IMAD"]
    },
    {
        name: "Anouk S.",
        specialties: ["Runes Viking", "Protection", "Famille"],
        description: "J'utilise les Runes, un support ancestral puissant, pour protéger votre foyer et anticiper les conflits. Une voyance directe, brute, connectée aux forces de la nature.",
        imageUrl: "https://randomuser.me/api/portraits/women/52.jpg",
        status: 'available',
        rating: 4.7,
        reviews: 3128,
        experienceYears: 12,
        tags: ["Certifié IMAD", "Top Expert"]
    },
    {
        name: "Sébastien L.",
        specialties: ["Clairaudience", "Anges Gardiens", "Guidance"],
        description: "Je transmets les messages de vos guides spirituels. Si vous vous sentez perdu(e), je vous remets sur le chemin de votre destinée. Une consultation apaisante et lumineuse.",
        imageUrl: "https://randomuser.me/api/portraits/men/74.jpg",
        status: 'busy',
        rating: 4.9,
        reviews: 7890,
        experienceYears: 13,
        tags: ["Certifié IMAD", "Coup de Cœur"]
    },
    {
        name: "Yasmine B.",
        specialties: ["Cafédomancie", "Voyance Orientale", "Amour"],
        description: "Héritière d'une longue lignée de voyantes, je lis l'avenir dans le marc de café. Spécialiste des unions et des mariages. Je vois les obstacles et comment les contourner.",
        imageUrl: "https://randomuser.me/api/portraits/women/62.jpg",
        status: 'available',
        rating: 4.8,
        reviews: 4567,
        experienceYears: 10,
        tags: ["Certifié IMAD", "Nouveau"]
    },
    {
        name: "Victor H.",
        specialties: ["Radiesthésie", "Géobiologie", "Énergies"],
        description: "Je ressens les vibrations des lieux et des personnes. Si vous sentez une lourdeur chez vous ou dans votre couple, je détecte la source du problème immédiatement.",
        imageUrl: "https://randomuser.me/api/portraits/men/29.jpg",
        status: 'available',
        rating: 4.6,
        reviews: 2215,
        experienceYears: 9,
        tags: ["Certifié IMAD"]
    },
    {
        name: "Rose-Marie",
        specialties: ["Grand Tarot", "Psychologie", "Deuil"],
        description: "Psychologue de formation, j'ai développé mes dons pour aller plus loin que la thérapie. J'aide à traverser les épreuves difficiles (deuil, divorce) avec le support du Tarot.",
        imageUrl: "https://randomuser.me/api/portraits/women/12.jpg",
        status: 'busy',
        rating: 5.0,
        reviews: 14201,
        experienceYears: 16,
        tags: ["Certifié IMAD", "Référence"]
    },
    {
        name: "Dimitri K.",
        specialties: ["Voyance Flash", "Temps", "Précision"],
        description: "Je suis réputé pour ma précision temporelle. Vous voulez savoir 'Quand' ? Je vous donne des périodes précises. Flashs rapides sans support.",
        imageUrl: "https://randomuser.me/api/portraits/men/91.jpg",
        status: 'available',
        rating: 4.7,
        reviews: 6234,
        experienceYears: 11,
        tags: ["Certifié IMAD", "Top Expert"]
    },
    {
        name: "Luna P.",
        specialties: ["Astrologie Lunaire", "Féminin Sacré", "Grossesse"],
        description: "J'accompagne les femmes dans leurs cycles de vie. Fertilité, grossesse, ménopause, mais aussi intuition et pouvoir personnel. Une voyance par et pour les femmes.",
        imageUrl: "https://randomuser.me/api/portraits/women/28.jpg",
        status: 'available',
        rating: 4.8,
        reviews: 3892,
        experienceYears: 10,
        tags: ["Certifié IMAD", "Coup de Cœur"]
    },
     {
        name: "Gabriel A.",
        specialties: ["Écriture Automatique", "Messager", "Mystique"],
        description: "Je prends un stylo et je laisse les guides écrire à travers moi. Des messages bouleversants de vérité qui ne viennent pas de moi, mais de l'au-delà.",
        imageUrl: "https://randomuser.me/api/portraits/men/18.jpg",
        status: 'available',
        rating: 4.5,
        reviews: 1563,
        experienceYears: 8,
        tags: ["Certifié IMAD", "Nouveau"]
    }
];

// Générateur pseudo-aléatoire déterministe pour synchroniser à 100% le client et le serveur
let seedCounter = 12345;
function seededRandom(): number {
    const x = Math.sin(seedCounter++) * 10000;
    return x - Math.floor(x);
}

function seededShuffle<T>(array: T[]): T[] {
    const newArr = [...array];
    for (let i = newArr.length - 1; i > 0; i--) {
        const j = Math.floor(seededRandom() * (i + 1));
        [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
}

export const generateMediums = (): Medium[] => {
  seedCounter = 12345; // Reset de la graine pour une génération identique
  const mediums: Medium[] = [];

  // 1. Identification des images utilisées par les Stars
  const usedWomenIds = new Set<number>();
  const usedMenIds = new Set<number>();

  STAR_MEDIUMS.forEach((star, index) => {
    if (star.imageUrl) {
        const match = star.imageUrl.match(/portraits\/(women|men)\/(\d+)\.jpg/);
        if (match) {
            const gender = match[1];
            const id = parseInt(match[2], 10);
            if (gender === 'women') usedWomenIds.add(id);
            if (gender === 'men') usedMenIds.add(id);
        }
    }

    const starMeta: Record<string, { domain: MediumDomain; isVip: boolean; extraTags?: string[] }> = {
        "Maud K.": { domain: "Amour", isVip: true, extraTags: ["VIP Privilège"] },
        "David S.": { domain: "Travail", isVip: true, extraTags: ["VIP Privilège"] },
        "Sarah L.": { domain: "Amour", isVip: true, extraTags: ["VIP Privilège"] },
        "Raphaël V.": { domain: "Amour", isVip: false },
        "Estelle B.": { domain: "Amour", isVip: true, extraTags: ["VIP Privilège"] },
        "Claude M.": { domain: "Travail", isVip: false },
        "Elena R.": { domain: "Amour", isVip: false },
        "Marc D.": { domain: "Finance", isVip: true, extraTags: ["VIP Privilège"] },
        "Sofia M.": { domain: "Amour", isVip: false },
        "Lucas T.": { domain: "Amour", isVip: false },
        "Chloé V.": { domain: "Finance", isVip: false },
        "Jean-Pierre": { domain: "Finance", isVip: true, extraTags: ["VIP Privilège"] },
        "Anouk S.": { domain: "Travail", isVip: false },
        "Sébastien L.": { domain: "Travail", isVip: false },
        "Yasmine B.": { domain: "Amour", isVip: false },
        "Victor H.": { domain: "Finance", isVip: false },
        "Rose-Marie": { domain: "Amour", isVip: true, extraTags: ["VIP Privilège"] },
        "Dimitri K.": { domain: "Travail", isVip: true, extraTags: ["VIP Privilège"] },
        "Luna P.": { domain: "Amour", isVip: false },
        "Gabriel A.": { domain: "Finance", isVip: false }
    };
    const meta = star.name && starMeta[star.name] ? starMeta[star.name] : { domain: "Amour" as MediumDomain, isVip: index % 4 === 0 };
    const starTags = [...(star.tags || ["Certifié IMAD"])];
    if (meta.isVip && !starTags.includes("VIP Privilège")) {
        starTags.push("VIP Privilège");
    }

    mediums.push({
        id: index + 1,
        name: star.name!,
        specialties: star.specialties!,
        rating: star.rating!,
        reviews: star.reviews!,
        reviewsList: generateReviews(star.reviews!), 
        status: star.status as 'available' | 'busy' | 'away',
        imageUrl: star.imageUrl!,
        description: star.description!,
        experienceYears: star.experienceYears!,
        tags: starTags,
        temperament: star.temperament || 'chaleureux',
        domain: meta.domain,
        isVip: meta.isVip
    });
  });

  // 2. Gestion des IDs disponibles pour les autres
  let availableWomenIds: number[] = [];
  let availableMenIds: number[] = [];

  for (let i = 0; i < 100; i++) {
      if (!usedWomenIds.has(i)) availableWomenIds.push(i);
      if (!usedMenIds.has(i)) availableMenIds.push(i);
  }

  availableWomenIds = seededShuffle(availableWomenIds);
  availableMenIds = seededShuffle(availableMenIds);

  const targetTotal = 150; 
  let currentId = mediums.length + 1;

  while (mediums.length < targetTotal) {
    let wantFemale = seededRandom() > 0.4;
    let selectedId: number | undefined;
    let isFemale = false;

    if (wantFemale) {
        if (availableWomenIds.length > 0) {
            selectedId = availableWomenIds.pop();
            isFemale = true;
        } else if (availableMenIds.length > 0) {
            selectedId = availableMenIds.pop();
            isFemale = false;
        }
    } else {
        if (availableMenIds.length > 0) {
            selectedId = availableMenIds.pop();
            isFemale = false;
        } else if (availableWomenIds.length > 0) {
            selectedId = availableWomenIds.pop();
            isFemale = true;
        }
    }

    if (selectedId === undefined) break;

    const genderStr = isFemale ? 'women' : 'men';
    const finalImageUrl = `https://randomuser.me/api/portraits/${genderStr}/${selectedId}.jpg`;

    const nameList = isFemale ? femaleNames : maleNames;
    const firstName = nameList[Math.floor(seededRandom() * nameList.length)];
    const lastNameInitial = String.fromCharCode(65 + Math.floor(seededRandom() * 26));
    const name = `${firstName} ${lastNameInitial}.`;
    
    let spec1 = specialtiesList[Math.floor(seededRandom() * specialtiesList.length)];
    let spec2 = specialtiesList[Math.floor(seededRandom() * specialtiesList.length)];
    
    const rand = seededRandom();
    if (rand < 0.25) spec1 = "Spécialiste Amour & Couple";
    else if (rand < 0.40) spec1 = "Coach Carrière & Travail";
    else if (rand < 0.60) spec1 = "Expertise Argent & Finances";

    while (spec1 === spec2) spec2 = specialtiesList[Math.floor(seededRandom() * specialtiesList.length)];

    let status: 'available' | 'busy' | 'away' = 'away';
    const statusRoll = seededRandom();
    if (statusRoll > 0.7) status = 'available';
    else if (statusRoll > 0.5) status = 'busy';

    const desc = `Médium ${(spec1 || '').toLowerCase()}. ${seededRandom() > 0.5 ? "Je ne pose aucune question." : "Votre voix est mon support."} Je suis là pour vous aider à y voir plus clair dans votre avenir avec honnêteté et bienveillance.`;

    const baseRating = 3.0 + seededRandom() * 2.0; 
    const finalRating = Math.min(baseRating, 5.0);

    const tags: string[] = ["Certifié IMAD"];
    const tagRand = seededRandom();
    if (finalRating > 4.7) tags.push("Top Expert");
    if (tagRand > 0.85) tags.push("Coup de Cœur");
    if (tagRand < 0.15) tags.push("Nouveau");

    // --- GÉNÉRATION DÉTERMINISTE DU NOMBRE DE CONSULTATIONS ---
    let reviewsCount;
    const popularityRoll = seededRandom();

    if (popularityRoll > 0.90) {
        reviewsCount = Math.floor(seededRandom() * (5800 - 1500 + 1)) + 1500;
    } else if (popularityRoll > 0.50) {
        reviewsCount = Math.floor(seededRandom() * (1500 - 300 + 1)) + 300;
    } else {
        reviewsCount = Math.floor(seededRandom() * (300 - 28 + 1)) + 28;
    }

    const poolTemperaments: MediumTemperament[] = ['sensuel', 'strict', 'chaleureux', 'mystique', 'analytique'];
    let assignedTemperament: MediumTemperament = poolTemperaments[currentId % poolTemperaments.length];
    
    // Attribution du domaine déterminée par roulement harmonieux
    const domainMod = currentId % 3;
    let assignedDomain: MediumDomain = 'Amour';
    if (domainMod === 0) {
      assignedDomain = 'Amour';
      spec1 = seededRandom() > 0.5 ? "Spécialiste Amour & Couple" : "Retour Affectif & Destinée";
      assignedTemperament = 'sensuel';
    } else if (domainMod === 1) {
      assignedDomain = 'Travail';
      spec1 = seededRandom() > 0.5 ? "Coach Carrière & Projets" : "Orientation & Réussite Pro";
      assignedTemperament = 'analytique';
    } else {
      assignedDomain = 'Finance';
      spec1 = seededRandom() > 0.5 ? "Expertise Argent & Finances" : "Patrimoine & Déblocage Matériel";
      assignedTemperament = 'analytique';
    }

    // Médiums VIP d'élite (+1000 Astres requis)
    const isVipCandidate = (currentId % 5 === 0) || (finalRating >= 4.9 && seededRandom() > 0.35);
    if (isVipCandidate) {
      if (!tags.includes("VIP Privilège")) tags.push("VIP Privilège");
    }

    mediums.push({
      id: currentId,
      name: name,
      specialties: [spec1, spec2],
      rating: Number(finalRating.toFixed(1)),
      reviews: reviewsCount, 
      reviewsList: generateReviews(reviewsCount), 
      status: status,
      imageUrl: finalImageUrl,
      description: desc,
      experienceYears: Math.floor(seededRandom() * 10) + 8,
      tags: tags,
      temperament: assignedTemperament,
      domain: assignedDomain,
      isVip: isVipCandidate
    });
    
    currentId++;
  }
  
  return mediums;
};

export const SARAH_MEDIUM: Medium = {
    id: 9999,
    name: "Secrétariat Sarah",
    role: "Secrétariat & Support Client",
    experience: "15 ans",
    specialties: ["Support Client", "Facturation", "Assistance"],
    imageUrl: "/sarah.jpg",
    description: "Secrétariat et support client AstroX.",
    rating: 5.0,
    reviews: 450,
    reviewsList: [],
    status: 'available',
    isOnline: true,
    pricePerMinute: 0,
    tags: ["Officiel", "Secrétariat"]
};

// Liste statique de base
export const ALL_MEDIUMS = generateMediums();

// --- FONCTION DE FILTRE DYNAMIQUE SELON L'HEURE ---
export const getCurrentMediumsStatus = (): Medium[] => {
    // --- 1. VÉRIFICATION DE L'OVERRIDE GLOBAL ADMIN ---
    const globalStatusOverride = localStorage.getItem('admin_medium_global_status');

    if (globalStatusOverride === 'force_online') {
        return ALL_MEDIUMS.map(m => ({ ...m, status: 'available' } as Medium));
    }

    if (globalStatusOverride === 'force_offline') {
        return ALL_MEDIUMS.map(m => ({ ...m, status: 'away' } as Medium));
    }

    // --- 2. LOGIQUE NORMALE (AUTO) ---
    const now = new Date();
    const hour = now.getHours();

    const isNightClosed = hour >= 23 || hour < 7;

    return ALL_MEDIUMS.map((m) => {
        if (isNightClosed) {
            return { ...m, status: 'away' } as Medium;
        }
        return m;
    }).sort((a, b) => {
        const statusOrder = { available: 0, busy: 1, away: 2 };
        return statusOrder[a.status] - statusOrder[b.status];
    });
};

// --- HELPERS DOMAINE ET VIP ---
export const getMediumDomain = (medium: Medium | Partial<Medium>): MediumDomain => {
  if (medium.domain) return medium.domain;
  const text = `${medium.name || ''} ${(medium.specialties || []).join(' ')} ${(medium.tags || []).join(' ')} ${medium.description || ''}`.toLowerCase();
  if (text.includes('argent') || text.includes('finance') || text.includes('patrimoine') || text.includes('immobilier') || text.includes('richesse') || text.includes('gain')) {
    return 'Finance';
  }
  if (text.includes('travail') || text.includes('carrière') || text.includes('carriere') || text.includes('professionnel') || text.includes('pro') || text.includes('entreprise') || text.includes('affaires') || text.includes('projet')) {
    return 'Travail';
  }
  return 'Amour';
};

export const isMediumVip = (medium: Medium | Partial<Medium>): boolean => {
  if (medium.isVip !== undefined) return Boolean(medium.isVip);
  if (medium.tags && (medium.tags.includes('VIP Privilège') || medium.tags.includes('VIP'))) return true;
  if (medium.id && [1, 2, 3, 5, 8, 12, 17, 18].includes(medium.id)) return true;
  return false;
};
